import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=7544608a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7544608a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7544608a')) {
      api.createRecord('7544608a', component.options)
    } else {
      api.reload('7544608a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=7544608a&scoped=true&", function () {
      api.rerender('7544608a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tv6drpUt1QR7/JS/comp/SearchFilterTokens.vue"
export default component.exports